// global
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';
import { connect } from 'react-redux';

class PrivateRoute extends React.Component {
    render() {
        const { component: RouteComponent, auth, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={props => {
                    // the render method is called each time the page re-render.
                    if (auth.isAuthenticated) {
                        return <RouteComponent {...props} />;
                    } else {
                        return (
                            <Redirect
                                to={{
                                    pathname: '/login',
                                    state: { from: props.location },
                                }}
                            />
                        );
                    }
                }}
            />
        );
    }
}

PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
});
export default connect(mapStateToProps)(PrivateRoute);
